import { useCallback, useEffect, useRef, useState } from 'react';

export const useSearchBarState = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const searchTriggerRef = useRef<HTMLButtonElement>(null);
  const restoreFocusRef = useRef(false);

  useEffect(() => {
    if (!isSearchVisible && restoreFocusRef.current) {
      searchTriggerRef.current?.focus({ preventScroll: true });
      restoreFocusRef.current = false;
    }
  }, [isSearchVisible]);

  const closeSearch = useCallback(() => {
    restoreFocusRef.current = true;
    setIsSearchVisible(false);
    setSearchQuery('');
  }, []);

  const openSearch = useCallback(() => {
    restoreFocusRef.current = false;
    setIsSearchVisible(true);
  }, []);

  return {
    searchQuery,
    setSearchQuery,
    isSearchVisible,
    openSearch,
    closeSearch,
    searchTriggerRef,
  };
};
